module.exports = __webpack_public_path__ + "img/4.76f50ab4.png";